// Shared wrestler icon helpers
// Used across RosterTab, RosterReview, DraftPage, BookingPage, etc.

export const CLASS_COLORS = {
  'Fighter': '#3498db', 'Bruiser': '#e74c3c', 'Cruiser': '#2ecc71',
  'Specialist': '#9b59b6', 'Giant': '#e67e22'
};

export const getClassIcon = (cls) =>
  process.env.PUBLIC_URL + '/icons/class-' + (cls || '').toLowerCase() + '.png';

export const getRoleIcon = (heel) =>
  process.env.PUBLIC_URL + '/icons/role-' + (heel ? 'heel' : 'face') + '.png';

export const getXPBadge = (xp) => {
  const n = Number(xp) || 0;
  if (n >= 25) return process.env.PUBLIC_URL + '/icons/xp-badge-5.png';
  if (n >= 20) return process.env.PUBLIC_URL + '/icons/xp-badge-4.png';
  if (n >= 15) return process.env.PUBLIC_URL + '/icons/xp-badge-3.png';
  if (n >= 10) return process.env.PUBLIC_URL + '/icons/xp-badge-2.png';
  return process.env.PUBLIC_URL + '/icons/xp-badge-1.png';
};
